import { render } from "./OutlineForResource.vue?vue&type=template&id=1bae628b&scoped=true"
import script from "./OutlineForResource.vue?vue&type=script&lang=js"
export * from "./OutlineForResource.vue?vue&type=script&lang=js"

import "./OutlineForResource.vue?vue&type=style&index=0&id=1bae628b&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bae628b"]])

export default __exports__